// extracted by mini-css-extract-plugin
export default {"square":"Square_square__TnXTC","winnerAnimation":"Square_winnerAnimation__Tzc33","winner":"Square_winner__TpDrF"};